import axios from '@/http'

//获取互动开关状态接口
export function getInteractiveStatus(data) {
    return axios({
        url: '/api/akadm-webservice/get-class-interactive-status',
        method: 'GET',
        params: data
    })
}

//获取token接口
export function getWsToken() {
    return axios({
        url: '/api/akadm-webservice/get-token',
        method: 'GET',
    })
}


//老师http方式锁屏/解锁接口
export function teacherLockScreen(data, host) {
    return axios({
        baseURL: host,
        url: '/api/akdm-service/teacher-lock-screen',
        method: 'GET',
        params: data
    })
}

//老师http方式锁屏/解锁接口
export function getTeacherLockScreen(data, host) {
    return axios({
        baseURL: host,
        dataType: 'json',
        url: '/api/akdm-service/get-lock-screen-status',
        method: 'GET',
        params: data
    })
}

//获取后台麦穗锁屏功能是否开启
export function getStuBookScreen() {
    return axios({
        url: '/api/akadm-webservice/get-stu-book-lock-screen-status',
        method: 'GET',
    })
}

//获取获取用户信息
export function getWsUserInfo() {
    return axios({
        url: '/api/akadm-webservice/get-user-info',
        method: 'GET',
    })
}


// 获取投图图片分页
export function getTeacherPicLogPages(data) {
    return axios({
        url: '/api/akadm-webservice/get-teacher-pic-log-pages',
        method: 'POST',
        data
    })
}

// 获取有投图的日期
export function getFileDays(data) {
    return axios({
        url: '/api/akadm-webservice/get-file-days',
        method: 'POST',
        data
    })
}

// 获取某天的投图列表
export function getFilesByDay(data) {
    return axios({
        url: '/api/akadm-webservice/get-files-by-date',
        method: 'POST',
        data
    })
}